import React from 'react';
import styles from './ScheduleListItem.module.scss';
import TimeSpan from '../TimeSpan/TimeSpan';
import Link from '../Link';

function ScheduleListItem(props) {
    const { className = '', icon, start, end, children, href } = props,
        Tag = href ? Link : 'div';

    return (
        <Tag className={[className, styles.ScheduleListItem].join(' ')} href={href}>
            <div className={styles.iconWrapper}>{icon}</div>
            <div className={styles.time}>
                <TimeSpan start={start} end={end} />
            </div>
            <div className={styles.content}>{children}</div>
        </Tag>
    );
}

export default ScheduleListItem;
